import React, { useState } from 'react';
import Popup from "../imagepopup";


function Bombardier() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };

  return (
    
    <section className="sec-box project section-padding radius-15">
        <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center">
              <div className="next ml-auto">
                <h6 className="sub-title back-to-work">
                  <a href="/works">
                  <i className="fas fa-long-arrow-alt-left"></i> Back to works
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="img mb-80">
            <img
              src="/assets/imgs/works/p4.jpg"
              alt=""
              className="radius-5"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="cont md-mb50">
              <h3 className="mb-15 fw-500">Project Description:</h3>
                <p>
                Designed and developed the Bombardier Customer Portal, a modern and intuitive platform that enhances customer interactions, document accessibility, and service request management. Focused on front-end UI/UX design and development, creating a visually engaging, responsive, and user-friendly experience tailored for Bombardier’s customers.
                </p>
                <p className="mt-15">
                Utilized HTML, CSS, JavaScript, and responsive frameworks to craft a clean and professional interface. Ensured seamless navigation and accessibility, allowing users to efficiently access technical publications, service requests, part orders, and event updates.
                </p>
                <div className="mt-30">
                <h6 className="mb-15 line-height-28">
                  Roles & Responsibilities:
                  </h6>
                  <p>As a <strong>UI/UX & Developer</strong>, I was responsible for:</p>
                  <ul className="rest list-arrow mt-50">
                    <li>
                      <h6 className="inline fz-15">
                      Dashboard & UI Design: Designed an interactive and structured dashboard, ensuring a visually appealing layout with clear content hierarchy.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      User-Centric Experience: Focused on intuitive navigation, making it easy for customers to access latest technical documents, repair manuals, and service bulletins.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Responsive Front-End Development: Developed a mobile-friendly and cross-browser-compatible interface using modern front-end technologies.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Content & Document Management UI: Designed sections for library updates, event news, and service requests, allowing users to efficiently browse and retrieve information.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Interactive Elements & Custom Components: Created dynamic sections, including event notifications, training updates, and parts ordering, ensuring an engaging user experience.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Performance Optimization: Ensured fast loading times and a smooth experience through UI optimizations and efficient CSS & JavaScript coding practices.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Brand Consistency & Aesthetics: Maintained Bombardier’s branding guidelines, using high-quality visuals and a professional design approach.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Collaboration with Stakeholders: Worked closely with business teams and developers to ensure the portal met customer expectations and business requirements.
                      </h6>
                    </li>
                  </ul>
                  <p className="mt-25">
                  This project significantly enhanced customer engagement and self-service capabilities, improving efficiency in accessing critical aviation documents, service requests, and training resources while delivering a modern and professional digital experience.
                    </p>
                
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="info sub-bg" id="sticky_item">
                <ul>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-calendar-alt mr-10"></i> Date :
                    </span>
                    <p>July 2016</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="fas fa-list-ul mr-10"></i> Categories :
                    </span>
                    <p>UI/UX Design</p>
                  </li>
                  <li>
                    <span className="sub-title">
                      <i className="far fa-user mr-10"></i> Client :
                    </span>
                    <p>Bombardier</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p12.jpg" alt=""  onClick={() => handleImageClick("/assets/imgs/works/p12.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p40.jpg" alt=""  onClick={() => handleImageClick("/assets/imgs/works/p40.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p39.jpg" alt=""  onClick={() => handleImageClick("/assets/imgs/works/p39.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
        
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center mt-80 pt-80 bord-thin-top">
              <div className="prev">
                <h6 className="sub-title">
                  <a href="/scotiabank">
                    <i className="fas fa-long-arrow-alt-left"></i> Prev Project
                  </a>
                </h6>
              </div>
              <div className="next ml-auto">
                <h6 className="sub-title">
                  <a href="/techmahindra">
                    next Project <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      
            
                  {/* Popup for images */}
                  <Popup
        isOpen={isPopupOpen}
        closePopup={closePopup}
        popupImage={selectedImage}
      />
    </section>
  );
}

export default Bombardier;
